import { render, staticRenderFns } from "./uploadPolicyDocument.vue?vue&type=template&id=43b61b51&scoped=true&lang=html"
import script from "./uploadPolicyDocument.vue?vue&type=script&lang=js"
export * from "./uploadPolicyDocument.vue?vue&type=script&lang=js"
import style0 from "./uploadPolicyDocument.vue?vue&type=style&index=0&id=43b61b51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b61b51",
  null
  
)

export default component.exports